import React, { Fragment } from "react";
import Moment from "react-moment";

const ApplicantItem = ({
  applicant,
  setShowMessages,
  setApplicantResume,
  setShowResume,
  setDeclineAcceptedApplicant,
}) => {
  return (
    <Fragment>
      {applicant.imeapplicant && applicant.imeresume && (
        <div className="applicant-user grey">
          <div className="job-post-date-alt">
            <i className="far fa-clock green"></i>
            <p className="mx-5 white">
              <Moment format="MM/DD/YYYY">{applicant.date}</Moment>
            </p>
          </div>
          <div className="sub-user">
            <div className="online-avi-container">
              <div className="avi-color-border-alt green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${applicant.avatar}`}
                  className="sub-avi"
                  alt="avi-two"
                />
              </div>
            </div>
            <div className="sub-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="name-font bold green">
                    {applicant.firstname} {applicant.lastname}
                  </span>
                </li>
                <li className="user-online-item">{applicant.email}</li>
                <li className="user-online-item">{applicant.jobtitle}</li>
                <li className="user-online-item">
                  {applicant.location.city}, {applicant.location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="applicant-buttons">
            <div className="action-items green">
              <div
                className="action-button"
                onClick={() => setShowMessages(true)}
              >
                <i className="far fa-comment action-icon fa-lg"></i>
              </div>
              <p className="action-text">
                View Messages
                <span className="green mx-5">(0)</span>
              </p>
            </div>
          </div>
          <button
            className="applicant-button-x background-dark-black white"
            onClick={() => {
              setApplicantResume({
                avatar: applicant ? applicant.avatar : "",
                firstname: applicant ? applicant.firstname : "",
                lastname: applicant ? applicant.lastname : "",
                jobtitle: applicant ? applicant.jobtitle : "",
                location: applicant ? applicant.location : "",
                imeapplicant: applicant ? applicant.imeapplicant : false,
                imeresume: applicant ? applicant.resume : false,
                professionalsummary: applicant.applicant.resume
                  .professionalsummary
                  ? applicant.resume.professionalsummary
                  : "",
                experience:
                  applicant.resume.experience.length > 0
                    ? [...applicant.resume.experience]
                    : [],
                education:
                  applicant.resume.education.length > 0
                    ? [...applicant.resume.education]
                    : [],
                skills:
                  applicant.resume.skills.length > 0
                    ? [...applicant.resume.skills]
                    : [],
              });
              setShowResume(true);
            }}
          >
            <i className="fas fa-file-alt blue mx-5"></i>
            View Resume
          </button>
          <button
            className="applicant-button-x background-dark-black red"
            onClick={() => {
              setApplicantResume({
                email: applicant ? applicant.email : "",
                avatar: applicant ? applicant.avatar : "",
                firstname: applicant ? applicant.firstname : "",
                lastname: applicant ? applicant.lastname : "",
                jobtitle: applicant ? applicant.jobtitle : "",
                location: applicant ? applicant.location : "",
                imeapplicant: applicant ? applicant.imeapplicant : false,
                imeresume: applicant ? applicant.resume : false,
                professionalsummary: applicant.applicant.resume
                  .professionalsummary
                  ? applicant.resume.professionalsummary
                  : "",
                experience:
                  applicant.resume.experience.length > 0
                    ? [...applicant.resume.experience]
                    : [],
                education:
                  applicant.resume.education.length > 0
                    ? [...applicant.resume.education]
                    : [],
                skills:
                  applicant.resume.skills.length > 0
                    ? [...applicant.resume.skills]
                    : [],
              });
              setDeclineAcceptedApplicant(true);
            }}
          >
            <i className="fas fa-times red mx-5"></i>
            Remove Applicant
          </button>
        </div>
      )}
      {applicant.imeapplicant && !applicant.imeresume && (
        <div className="applicant-user grey">
          <div className="job-post-date-alt">
            <i className="far fa-clock green"></i>
            <p className="mx-5 white">
              <Moment format="MM/DD/YYYY">{applicant.date}</Moment>
            </p>
          </div>
          <div className="sub-user">
            <div className="online-avi-container">
              <div className="avi-color-border-alt green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${applicant.avatar}`}
                  className="sub-avi"
                  alt="avi-two"
                />
              </div>
            </div>
            <div className="sub-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="name-font bold green">
                    {applicant.firstname} {applicant.lastname}
                  </span>
                </li>
                <li className="user-online-item">{applicant.email}</li>
                <li className="user-online-item">{applicant.jobtitle}</li>
                <li className="user-online-item">
                  {applicant.location.city}, {applicant.location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="applicant-buttons">
            <div className="action-items green">
              <div
                className="action-button"
                onClick={() => setShowMessages(true)}
              >
                <i className="far fa-comment action-icon fa-lg"></i>
              </div>
              <p className="action-text">
                View Messages
                <span className="green mx-5">(0)</span>
              </p>
            </div>
          </div>
          <button
            className="applicant-button-x background-dark-black white"
            onClick={() => {
              setApplicantResume({
                avatar: applicant ? applicant.avatar : "",
                firstname: applicant ? applicant.firstname : "",
                lastname: applicant ? applicant.lastname : "",
                jobtitle: applicant ? applicant.jobtitle : "",
                location: applicant ? applicant.location : "",
                imeapplicant: applicant ? applicant.imeapplicant : false,
                resumePath: applicant ? applicant.resumename : "",
                documentType: applicant ? applicant.documenttype : "",
              });
              setShowResume(true);
            }}
          >
            <i className="fas fa-file-alt blue mx-5"></i>
            View Resume
          </button>
          <button
            className="applicant-button-x background-dark-black red"
            onClick={() => {
              setApplicantResume({
                email: applicant ? applicant.email : "",
                avatar: applicant ? applicant.avatar : "",
                firstname: applicant ? applicant.firstname : "",
                lastname: applicant ? applicant.lastname : "",
                jobtitle: applicant ? applicant.jobtitle : "",
                location: applicant ? applicant.location : "",
                imeapplicant: applicant ? applicant.imeapplicant : false,
                // imeresume: applicant ? applicant.resume : false,
                // professionalsummary: applicant.applicant.resume
                //   .professionalsummary
                //   ? applicant.resume.professionalsummary
                //   : "",
                // experience:
                //   applicant.resume.experience.length > 0
                //     ? [...applicant.resume.experience]
                //     : [],
                // education:
                //   applicant.resume.education.length > 0
                //     ? [...applicant.resume.education]
                //     : [],
                // skills:
                //   applicant.resume.skills.length > 0
                //     ? [...applicant.resume.skills]
                //     : [],
              });
              setDeclineAcceptedApplicant(true);
            }}
          >
            <i className="fas fa-times red mx-5"></i>
            Remove Applicant
          </button>
        </div>
      )}
      {!applicant.resume && !applicant.imeapplicant && (
        <div className="applicant-user grey">
          <div className="job-post-date-alt">
            <i className="far fa-clock green"></i>
            <p className="mx-5 white">
              <Moment format="MM/DD/YYYY">{applicant.date}</Moment>
            </p>
          </div>
          <div className="applicant-sub-user">
            <div className="sub-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="name-font bold green">
                    {applicant.email}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <button
            className="applicant-button-x background-dark-black white"
            onClick={() => {
              setApplicantResume({
                firstname: applicant ? applicant.email : "",
                imeapplicant: applicant ? applicant.imeapplicant : false,
                resumePath: applicant ? applicant.resumename : "",
                documentType: applicant ? applicant.documenttype : "",
              });
              setShowResume(true);
            }}
          >
            <i className="fas fa-file-alt blue mx-5"></i>
            View Resume
          </button>
          <button
            className="applicant-button-x background-dark-black red"
            onClick={() => {
              setApplicantResume({
                email: applicant ? applicant.email : "",
                avatar: applicant ? applicant.avatar : "",
                firstname: applicant ? applicant.firstname : "",
                lastname: applicant ? applicant.lastname : "",
                jobtitle: applicant ? applicant.jobtitle : "",
                location: applicant ? applicant.location : "",
                imeapplicant: applicant ? applicant.imeapplicant : false,
                // imeresume: applicant ? applicant.resume : false,
                // professionalsummary: applicant.resume.professionalsummary
                //   ? applicant.resume.professionalsummary
                //   : "",
                // experience:
                //   applicant.resume.experience.length > 0
                //     ? [...applicant.resume.experience]
                //     : [],
                education:
                  applicant.resume.education.length > 0
                    ? [...applicant.resume.education]
                    : [],
                skills:
                  applicant.resume.skills.length > 0
                    ? [...applicant.resume.skills]
                    : [],
              });
              setDeclineAcceptedApplicant(true);
            }}
          >
            <i className="fas fa-times red mx-5"></i>
            Remove Applicant
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default ApplicantItem;
